import { Stack, Typography } from "@mui/material";

export default function DataGridCustomNoRowsOverlay(props) {
	const { message } = props;
	return (
		<Stack height="100%" alignItems="center" justifyContent="center">
			<Typography sx={{ fontSize: "1.5rem" }}>{message}</Typography>
		</Stack>
	);
}